import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import Grow from '@mui/material/Grow';
import CardMedia from '@mui/material/CardMedia';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { ListItemText } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import Imag from '../assets/img/j.png';
import {useEffect, useState} from 'react';


export default function AboutMe(){

    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [tam, setTam] = useState(null);

    const textico = "My name is Juliana, I’m a data scientist and web developer passionate about using technology to solve real-world problems. I’m efficient, analytic, and always eager to learn and grow. I’m studying a Master’s in Data Science and Artificial Intelligence, where I’ve been improving my skills in data analysis, machine learning, and data visualization. I love programming, exploring new ideas, and using data to discover insights that drive better decisions."

    useEffect(() => {
        function handleWindowResize() {
          setWindowSize(getWindowSize());
        }
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      }, []);

      useEffect(() => {

        if(windowSize.innerWidth >=700){
            setTam(6)
        }
        else{
            setTam(12)
        }
      });

    return(
        <Box>
            <Grid container rowSpacing={1}
            alignItems="center"
            justifyContent="center"
            sx={{position: 'absolute', zIndex: 1}}>
                <Grid item xs={6} alignItems="center"
                        justifyContent="center"
                        backgroundColor="black"
                        minHeight={1400}
                        >

                </Grid>
                <Grid item xs={6} alignItems="center"
                        justifyContent="center"
                        backgroundColor="#4dd0e1"
                        minHeight={1400}>
                </Grid>
            </Grid>

            


            
            <Grid container rowSpacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{position: 'absolute', zIndex: 2, mt: 15}}>
                <Grid item xs={2} pl={10} alignItems="center"
                        justifyContent="center"></Grid>
            <Slide direction="right" in={true} timeout={2000} mountOnEnter unmountOnExit>
                <Grid item xs={8} pl={10} alignItems="center"
                        justifyContent="center">
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <CardMedia
                            component="img"
                            sx={{maxWidth:"550px", height: "auto",objectFit: "contain",}}
                            image={Imag}
                            alt="juli"
                        />
                    </Box>
                </Grid>
            </Slide>
                <Grid item xs={2} pl={0} alignItems="center"
                        justifyContent="center"></Grid>

                <Grid item xs={7} pl={0} alignItems="center"
                        justifyContent="center">
                    <Box>

                    </Box>

                </Grid>

                <Grid item xs={tam-1} pr={10} pl={0} mt={3} alignItems="center"
                    justifyContent="center">

                        <Grow in={true} timeout={5000}>
                        {tam===12 ?( <Typography gutterBottom variant="h3" sx={{color:'white',
                        textTransform: "none",
                            fontFamily: 'Questrial',
                            "&:hover":{color:'white'}}}>
                                About me
                            </Typography>):
                            (<Typography gutterBottom variant="h3" sx={{textTransform: "none",
                            fontFamily: 'Questrial',
                            "&:hover":{color:'white'}}}>
                                About me
                            </Typography>)}
                        </Grow>

                        <Slide direction="right" in={true} timeout={2000} mountOnEnter unmountOnExit>
        
                            {tam===12 ? (<Typography gutterBottom variant="p" sx={{color:'white',
                            justifyContent:'center',
                            lineHeight: 1.8,
                            textShadow: '-1px 1px 10px rgba(0, 0, 0, 0.75)'}}>
                                {textico}
                            </Typography>)
                            :
                            (<Typography gutterBottom variant="p" sx={{lineHeight: 1.8}}>
                                {textico}
                            </Typography>)}
                        </Slide>

                </Grid>

                <Grid item xs={tam-2} pr={10} pl={0} mt={1} mb={15} alignItems="left"
                        justifyContent="left">
                    <Box color="primary" sx={{fontFamily: 'Questrial'}}>
                        <Typography gutterBottom variant="h5" color="primary" sx={{textTransform: "none",
                        fontFamily: 'Questrial',}}><CodeIcon fontSize="large" sx={{color: "white"}}/> Skills:</Typography>
                        <List>
                                <ListItem>
                                 <ListItemText sx={{color: "black", background:"white",fontFamily: 'Questrial'}}>Python, Numpy, Pandas, Matplotlib, PyTorch </ListItemText>
                                </ListItem>
                                <ListItem>
                                 <ListItemText sx={{color: "black", background:"white",fontFamily: 'Questrial'}}>TensorFlow, Scikit-Learn, R, JavaScript, HTML, CSS </ListItemText>
                                </ListItem>
                                <ListItem>
                                 <ListItemText sx={{color: "black", background:"white",fontFamily: 'Questrial'}}>React, NextJS, MYSQL, Eclipse, MicrosoftOffice    </ListItemText>
                                </ListItem>
                                <ListItem>
                                 <ListItemText sx={{color: "black", background:"white",fontFamily: 'Questrial'}}>Github, Fb Ads, Wordpress, Adobe suite, Figma    </ListItemText>
                                </ListItem>
                        </List>
                    </Box>

                </Grid>

                <Grid item xs={4} pr={9} alignItems="center"
                    justifyContent="center">
                    <Box>
                    </Box>
                </Grid>

            </Grid>
        </Box>
    )


    function getWindowSize() {
        const {innerWidth, innerHeight} = window;
        return {innerWidth, innerHeight};
      }

};